import { render, staticRenderFns } from "./AddBaseDataModal.vue?vue&type=template&id=cf0abff0&"
import script from "./AddBaseDataModal.vue?vue&type=script&lang=js&"
export * from "./AddBaseDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports